// Spanish (es-ES) result formatting shared by calendar, journal and dashboard.

const CURRENCY_SYMBOLS: Record<string, string> = {
  EUR: '\u20AC',
  USD: '$',
  GBP: '\u00A3',
  MXN: '$',
  ARS: '$',
  COP: '$'
}

export function currencySymbol(currency = 'EUR'): string {
  return CURRENCY_SYMBOLS[currency] ?? currency
}

export function fmtMoneyEs(n: number, signed = true, currency = 'EUR'): string {
  const sign = signed && n > 0 ? '+' : n < 0 ? '-' : ''
  const abs = Math.abs(n).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return `${sign}${abs} ${currencySymbol(currency)}`
}

export function fmtPctEs(n: number, signed = true): string {
  const sign = signed && n > 0 ? '+' : n < 0 ? '-' : ''
  const abs = Math.abs(n).toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return `${sign}${abs} %`
}

export function fmtCount(n: number): string {
  return `${n} ${n === 1 ? 'operación' : 'operaciones'}`
}
